<template>
    <v-card v-if="!hidden" :loading="loading" outlined class="widget-card" :class="{ 'is-dark': $vuetify.theme.dark }">
        <v-card-title v-if="title">{{ title }}</v-card-title>
        <v-card-text>
            <div v-if="error" class="widget-error">
                Couldn't load this widget.
                <v-btn icon small @click="$emit('retry')"><v-icon>mdi-refresh</v-icon></v-btn>
            </div>
            <div v-else-if="!loading && empty" class="widget-empty">
                <slot name="empty">No data for this event yet.</slot>
            </div>
            <slot v-else></slot>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'WidgetCard',
    props: {
        title: { type: String, default: '' },
        loading: { type: Boolean, default: false },
        error: { type: [Object, String], default: null },
        empty: { type: Boolean, default: false },
        hidden: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.widget-card { height: 100%; }
.widget-error { color: var(--v-error-base, #b71c1c); display: flex; align-items: center; gap: 8px; }
.widget-empty { color: rgba(0,0,0,0.54); font-style: italic; }
.is-dark .widget-empty { color: rgba(255,255,255,0.6); }
</style>
